import { TextType } from '@next-space/fe-api-idl';
import { newContent, newText } from '@next-space/fe-inlined';
import { LINK_TAG } from 'src/editor/editor/inline/const';
import { getEditorModelByEditorKey } from 'src/editor/editor/uikit/editable-models';
import { addBlock } from 'src/redux/managers/block/add';
import { cache } from 'src/redux/store';
import { isCollection } from 'src/utils/block-type-utils';
import { normalizeHref } from 'src/utils/embed';
import type { PasteHook } from '../types';
import { common } from './common';
import { PasteLinkPanel } from './paste-link-panel';

export const pasteLink = (
  { transaction, openModal }: PasteHook,
  event: ClipboardEvent | DragEvent,
  text: string,
  _url?: string
) => {
  const { insertInTitle, pos, where, posBlock, pageId, posEditorKey, focusEditableAt } = common();

  if (insertInTitle(text)) return;

  const url = _url || normalizeHref(text);

  transaction(() => {
    if (!pos) {
      if (isCollection(cache.blocks[pageId]?.type)) return;
      // 插入最后的时候不弹交互窗口
      const segment = { text, url, enhancer: {}, type: TextType.URL };
      addBlock({ data: { segments: [segment] } }, where);
    } else {
      const model = getEditorModelByEditorKey(posEditorKey || pos);

      if (model) {
        if (!model.selection) return;

        if (!model.selection.isCollapsed) {
          model.performChange((ctx) => {
            ctx.wrap(LINK_TAG, {
              url,
            });
            ctx.select(ctx.selection?.focusOffset, ctx.selection?.focusOffset);
          });
          return;
        }

        model.performChange((ctx) => {
          ctx.insert(
            newContent([
              {
                type: 'element',
                tag: LINK_TAG,
                props: { url },
                content: newContent([newText(text, ctx.format)]),
              },
            ])
          );
        });

        const cursorPos = model.selection.focusOffset;
        const isComment = !!(event.target as HTMLElement).closest('[data-is-comment]');
        const popcorn = {
          getBoundingClientRect: () => {
            const rect = model.getBoundingClientRectOfRange(cursorPos, cursorPos);
            return rect ?? (event.target as HTMLElement).getBoundingClientRect();
          },
        };
        openModal?.dropdown({
          popcorn,
          placement: 'bottom-start',
          content: ({ onCloseModal }) => (
            <PasteLinkPanel
              popcorn={popcorn}
              focusEditableAt={focusEditableAt}
              id={pos}
              url={url}
              model={model}
              isComment={isComment}
              cursorPos={cursorPos}
              posBlock={posBlock}
              onCloseModal={onCloseModal}
            />
          ),
        });
      }
    }
  });
};
